import { useAuth } from "../lib/auth";

export default function CommentReminderSettings({ form, setForm }) {
  const { store } = useAuth();
  if (store?.staff) return null;
  return (
    <div className="sms-box" data-testid="comment-reminder-settings">
      <h3 style={{ marginTop: 6 }}>Påmindelse på Facebook</h3>
      <label className="check" style={{ marginBottom: 6 }}>
        <input
          type="checkbox"
          checked={form.comment_reminder === "1"}
          onChange={(e) => setForm((f) => ({ ...f, comment_reminder: e.target.checked ? "1" : "0" }))}
          data-testid="comment-reminder-toggle"
        />{" "}
        Påmind i kommentaren på sidste afhentningsdag
      </label>
      <div className="hint" style={{ marginBottom: 10 }} data-testid="comment-reminder-hint">
        Botten svarer igen på kundens ja tak-kommentar på sidste afhentningsdag, hvis varen ikke er hentet endnu. Svaret er offentligt og indeholder kun fornavn og tidspunkt.
      </div>
    </div>
  );
}
